/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Submit_Translation_JobsInputs */

const en_submit_translation_jobs = /** @type {(inputs: Submit_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Submit ${i?.count} Translation Jobs`)
};

const fr_submit_translation_jobs = /** @type {(inputs: Submit_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Soumettre ${i?.count} traductions`)
};

const it_submit_translation_jobs = /** @type {(inputs: Submit_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invia ${i?.count} lavori di traduzione`)
};

const ru_submit_translation_jobs = /** @type {(inputs: Submit_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отправить ${i?.count} Заказы на перевод`)
};

const es_submit_translation_jobs = /** @type {(inputs: Submit_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviar ${i?.count} Trabajos de traducción`)
};

const zh_cn2_submit_translation_jobs = /** @type {(inputs: Submit_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`提交 ${i?.count} 翻译工作`)
};

const ja_submit_translation_jobs = /** @type {(inputs: Submit_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 翻訳案件を送信`)
};

const hi_submit_translation_jobs = /** @type {(inputs: Submit_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} अनुवाद कार्य जमा करें`)
};

const pt_pt2_submit_translation_jobs = /** @type {(inputs: Submit_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviar trabalhos de tradução ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Submit {count} Translation Jobs" |
*
* @param {Submit_Translation_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submit_translation_jobs = /** @type {((inputs: Submit_Translation_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_Translation_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_submit_translation_jobs(inputs)
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungsaufträge einreichen (PH_0__)")
	if (locale === "it") return it_submit_translation_jobs(inputs)
	if (locale === "ru") return ru_submit_translation_jobs(inputs)
	if (locale === "es") return es_submit_translation_jobs(inputs)
	if (locale === "zh-CN") return zh_cn2_submit_translation_jobs(inputs)
	if (locale === "ja") return ja_submit_translation_jobs(inputs)
	if (locale === "hi") return hi_submit_translation_jobs(inputs)
	if (locale === "pt-PT") return pt_pt2_submit_translation_jobs(inputs)
	return en_submit_translation_jobs(inputs)
});